<script setup lang="ts">
  const props = defineProps<{message: string|null|undefined, customClass?: string}>()

  const { getErrorMessageTokens } = useWadError();
  const { onSupportLinkClick, hasSupportChannel, supportHref } = useIntercomHelpers();

  // Some API messages mark the words that should open support, e.g.
  // "Account is suspended. Please <<contact support>> for help!". Nothing rendered those before,
  // because parseErrorFromException replaced every server message with the generic string, so
  // getErrorMessageTokens had no callers anywhere in the app. Now that the real message arrives
  // (TAL-10783), printing it raw would put the << >> markers on screen.
  const tokens = computed(() => getErrorMessageTokens(props.message ?? null));

  function contactSupport(event: Event) {
    onSupportLinkClick(event);
  }
</script>

<template>
  <div role="alert" :class="customClass ? customClass : 'wad4-generic-error'" v-if="!!message">
    <template v-for="(token, index) in tokens" :key="index">
      <a v-if="token.isLink && hasSupportChannel" :href="supportHref" @click="contactSupport">{{ token.text }}</a>
      <template v-else>{{ token.text }}</template>
    </template>
  </div>
</template>

<style lang="scss">
  .wad4-generic-error {
    @include text-size-mixin('md');
    color: $wad4-c-text-text-error;

    // Inherit the error colour rather than take the browser default, which puts a blue link in
    // the middle of a red sentence.
    a {
      color: inherit;
      text-decoration: underline;
      cursor: pointer;
    }
  }
</style>
